import { render, staticRenderFns } from "./WidgetPropertyFilter.vue?vue&type=template&id=e31979c2&scoped=true"
import script from "./WidgetPropertyFilter.vue?vue&type=script&lang=js"
export * from "./WidgetPropertyFilter.vue?vue&type=script&lang=js"
import style0 from "./WidgetPropertyFilter.vue?vue&type=style&index=0&id=e31979c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31979c2",
  null
  
)

export default component.exports